import { render, staticRenderFns } from "./SleepRecord.vue?vue&type=template&id=241a5db2&scoped=true"
import script from "./SleepRecord.vue?vue&type=script&lang=js"
export * from "./SleepRecord.vue?vue&type=script&lang=js"
import style0 from "./SleepRecord.vue?vue&type=style&index=0&id=241a5db2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241a5db2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('241a5db2')) {
      api.createRecord('241a5db2', component.options)
    } else {
      api.reload('241a5db2', component.options)
    }
    module.hot.accept("./SleepRecord.vue?vue&type=template&id=241a5db2&scoped=true", function () {
      api.rerender('241a5db2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inspect/SleepRecord.vue"
export default component.exports